module.exports = __webpack_public_path__ + "static/media/backArrow.1c0b04b1.svg";